import { atomWithReset } from "jotai/utils";

//                              pending   no state      id
type CurrentHotspotEventData = "pending" | undefined | string;

export const currentHotspotEventDataAtom = atomWithReset<CurrentHotspotEventData>(undefined);